// extracted by mini-css-extract-plugin
export default {"container":"UpdateEvent_container__8y0Ir","barContainer":"UpdateEvent_barContainer__5NS66"};